export const countries = [
  {
    name: "Germany",
    cities: ["Berlin", "Hamburg", "Munich", "Cologne", "Frankfurt"]
  },
  {
    name: "Poland",
    cities: ["Warsaw", "Krakow", "Lodz", "Wroclaw", "Poznan"]
  },
  {
    name: "Ukraine",
    cities: ["Kyiv", "Kharkiv", "Odesa", "Dnipro", "Lviv"]
  },
  {
    name: "Spain",
    cities: ["Madrid", "Barcelona", "Valencia", "Seville", "Zaragoza"]
  },
  {
    name: "Italy",
    cities: ["Rome", "Milan", "Naples", "Turin", "Palermo"]
  },
  {
    name: "United States",
    cities: ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix"]
  },
  {
    name: "France",
    cities: ["Paris", "Marseille", "Lyon", "Toulouse", "Nice"]
  },
  {
    name: "England",
    cities: ["London", "Birmingham", "Manchester", "Liverpool", "Leeds"]
  }
];
